import { keymap } from "prosemirror-keymap";
import { Extension } from "../../core/extension";
import { bindCommandToKey, toggleMark } from "../../commands/commands";
import { underlineMarkSpec } from "./schema";
export class UnderlineExtension extends Extension {
    addMarks(marks) {
        return marks.append(underlineMarkSpec());
    }
    addCommands(schema) {
        return {
            toggleUnderline: toggleMark(schema.marks.underline),
        };
    }
    addPlugins(schema, plugins, { commands }) {
        return plugins.concat([
            keymap({
                "Mod-u": bindCommandToKey(commands.toggleUnderline),
            }),
        ]);
    }
}
